import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/builder',
    name: 'builder',
    component: () => import('@/modules/Builder/pages/BuilderView.vue'),
    meta: {
      title: "CV Yaratish — cvLab",
      description: "CV yarating — shablonni tanlang, ma'lumotlaringizni kiriting va PDF yuklab oling.",
    },
  },
]

export default routes
